var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78516 10.0935H8.90791V16.2162C8.90791 16.544 9.17331 16.81 9.50166 16.81C9.83 16.81 10.0954 16.544 10.0954 16.2162V10.0935H16.2182C16.5465 10.0935 16.8119 9.82745 16.8119 9.4997C16.8119 9.17195 16.5465 8.90595 16.2182 8.90595H10.0954V2.7832C10.0954 2.45545 9.83 2.18945 9.50166 2.18945C9.17331 2.18945 8.90791 2.45545 8.90791 2.7832V8.90595H2.78516C2.45681 8.90595 2.19141 9.17195 2.19141 9.4997C2.19141 9.82745 2.45741 10.0935 2.78516 10.0935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlus);
export default __webpack_public_path__ + "static/media/white-plus.bc4669dad6a15665ed922fecafecd45d.svg";
export { ForwardRef as ReactComponent };